/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openthispagefromthelinkinyourpasswordresetemail10Inputs */

const en_openthispagefromthelinkinyourpasswordresetemail10 = /** @type {(inputs: Openthispagefromthelinkinyourpasswordresetemail10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open this page from the link in your password reset email.`)
};

const de_openthispagefromthelinkinyourpasswordresetemail10 = /** @type {(inputs: Openthispagefromthelinkinyourpasswordresetemail10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne diese Seite über den Link in deiner E-Mail zum Zurücksetzen des Passworts.`)
};

/**
* | output |
* | --- |
* | "Open this page from the link in your password reset email." |
*
* @param {Openthispagefromthelinkinyourpasswordresetemail10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const openthispagefromthelinkinyourpasswordresetemail10 = /** @type {((inputs?: Openthispagefromthelinkinyourpasswordresetemail10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openthispagefromthelinkinyourpasswordresetemail10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openthispagefromthelinkinyourpasswordresetemail10(inputs)
	return de_openthispagefromthelinkinyourpasswordresetemail10(inputs)
});
export { openthispagefromthelinkinyourpasswordresetemail10 as "openThisPageFromTheLinkInYourPasswordResetEmail" }